<!--
 * @Author: DY
 * @Date: 2024-12-05 16:55:29
 * @LastEditTime: 2025-04-09 15:00:08
 * @Description: 柴油领用申请表单
 * @FilePath: \ShiMo_Mobile\src\views\storage\dieselFuelRequisitionApproval\form.vue
-->
<template>
    <v-touch @swiperight="closeAllocationForm" class="wrapper">
        <div class="dieselFuelRequisitionApprovalForm commonFormStyles">
            <HeaderNav header-title="柴油领用申请表" left-icon-name="2" right-icon-name="3" :extr="{ leftCallBack: closeAllocationForm }"></HeaderNav>
            <section>
                <van-tabs class="currencyTabsStyle" v-model="activeTab" animated :scrollspy="false">
                    <van-tab title="申请信息表">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>申请信息表</h5>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="柴油出库单号"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.OutstockNumber"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="车牌号"
                                        placeholder="选择车牌号"
                                        :left-icon="require('@/assets/images/icons/icon_18@2x.png')"
                                        v-model="formData.CarLicense"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="车辆类型"
                                        placeholder="选择车牌号"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="formData.CarType"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="车辆管理部门"
                                        placeholder="选择车牌号"
                                        :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                                        v-model="formData.ManageDeptName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="成本中心"
                                        placeholder="选择车牌号"
                                        :left-icon="require('@/assets/images/icons/icon_21@2x.png')"
                                        v-model="formData.CostCenter"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="领用部门负责人"
                                        placeholder="选择车牌号"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.ManageDeptUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="仓库名称"
                                        placeholder="选择仓库"
                                        :left-icon="require('@/assets/images/icons/icon_47@2x.png')"
                                        v-model="formData.StockName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="库管员"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.StoremanName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="申请人"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.Creator"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="申请时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.CreationTime"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库人"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.OutstockUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.OutstockTime"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="状态"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="Status"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="备注"
                                        type="textarea"
                                        :rows="2"
                                        :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                        v-model="formData.Remarks"
                                    ></van-field>
                                </li>
                                <li class="photoUpload">
                                    <van-cell title="照片上传" :icon="require('@/assets/images/icons/icon_24@2x.png')"></van-cell>
                                    <div class="file-list">
                                        <van-uploader
                                            multiple
                                            preview-image
                                            preview-full-image
                                            v-model="fileList"
                                            upload-icon="plus"
                                            :deletable="false"
                                            :show-upload="false"
                                        ></van-uploader>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="申请明细表">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>申请明细表</h5>
                                </li>
                                <dl class="materialList" v-for="(item, index) in formData.Materials" :key="`material_${index}`">
                                    <dt>
                                        <h5>物料代码</h5>
                                        <p>{{ item.MaterialCode }}</p>
                                    </dt>
                                    <dd>
                                        <div>
                                            <p>短描述：</p>
                                            <input type="text" disabled v-model="item.MaterialShortName">
                                        </div>
                                        <div>
                                            <p>长描述：</p>
                                            <input type="text" disabled v-model="item.MaterialName">
                                        </div>
                                        <div>
                                            <p>单位：</p>
                                            <input type="text" disabled v-model="item.Unit">
                                        </div>
                                        <div>
                                            <p>柴油出库量(L)：</p>
                                            <input type="text" v-model="item.VolumeOutstockL" :disabled="isDisabled || formData.Status != 3" @change="countVolumeOutstock(item)">
                                        </div>
                                        <div>
                                            <p>折算系数：</p>
                                            <input type="text" v-model="item.VolumeCoefficient" :disabled="isDisabled || formData.Status != 3" @change="countVolumeOutstock(item)">
                                        </div>
                                        <div>
                                            <p>柴油出库量(千克)：</p>
                                            <input disabled type="text" v-model="item.VolumeOutstock">
                                        </div>
                                        <div @click="selectGrid">
                                            <p>存放位置：</p>
                                            <input readonly type="text" v-model="item.GridName" :disabled="isDisabled || formData.Status != 3">
                                        </div>
                                        <div>
                                            <p>出库前库存：</p>
                                            <input disabled type="text" v-model="item.VolumeCurrent">
                                        </div>
                                        <div>
                                            <p>出库后库存：</p>
                                            <input type="number" v-model="item.VolumeAfter" :disabled="isDisabled || formData.Status != 3">
                                        </div>
                                    </dd>
                                </dl>
                            </ul>
                        </div>
                    </van-tab>
                </van-tabs>
            </section>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <!-- 部门负责人可提交 -->
                    <button class="confirm" v-if="formData.Id != '' && formData.Status == 1" @click="submitForm(3)">
                        提交
                    </button>
                    <!-- 库管员可出库 -->
                    <button class="confirm" v-if="formData.Status == 3" @click="submitForm(4)">
                        确认出库
                    </button>
                    <!-- 部门负责人、库管员可退回 -->
                    <button class="confirm" v-if="[1, 3].includes(formData.Status)" @click="submitForm(2)">
                        退回
                    </button>
                </template>
                <button class="confirm" @click="closeAllocationForm">
                    关闭
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
export default {
    name: 'diesel-fuel-requisition-approval-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/dieselFuelRequisitionApproval') {
            this.$store.commit('noKeepAlive', 'diesel-fuel-requisition-approval-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            isDisabled: false,
            activeTab: 0,
            formData: {
                Id: '',
                OutstockNumber: '',
                OutstockUserId: '',
                OutstockUserName: '',
                OutstockTime: '',
                Status: 0,
                Remarks: '',
                AutoIndex: 0,
                YearIndex: '',
                CarLicense: '',
                ManageDeptId: '',
                ManageDeptName: '',
                CarType: 0,
                CostCenter: '',
                ManageDeptUserId: '',
                ManageDeptUserName: '',
                PictureId: '',
                StockId: '',
                StockCode: '',
                StockName: '',
                StoremanId: '',
                StoremanName: '',
                StoremanPhone: '',
                Creator: '',
                CreationTime: '',
                Materials: [],
            },
            Status: '',
            fileList: [],
            isSaveOperation: false,
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.grid) {
            this.formData.Materials[0].GridId = this.$route.params.grid[0].grid_id;
            this.formData.Materials[0].GridCode = this.$route.params.grid[0].grid_code;
            this.formData.Materials[0].GridName = this.$route.params.grid[0].grid_name;
            this.formData.Materials[0].VolumeCurrent = this.$route.params.grid[0].volume_current;
            this.formData.Materials[0].VolumeAfter = NP.minus(this.formData.Materials[0].VolumeCurrent || 0, this.formData.Materials[0].VolumeOutstock || 0);
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        async initpage() {
            this.$toast.loading({ overlay: true, duration: 0 });
            const type = this.$route.params.type;
            this.formData = await this.getFormData(this.$route.params.data.id);
            if ((this.formData.PictureId || '') !== '') {
                const fileData = this.formData.PictureId.split(',');
                this.loadFile(fileData);
            }
            if (type === 'see') {
                this.isDisabled = true;
            }
            this.Status = this.loadStatus(this.formData.Status);
            this.$toast.clear();
        },
        loadStatus(nub) {
            const staus = ['待提交', '待审核', '未通过', '待出库', '已出库', '已作废'];
            return staus[nub];
        },
        loadFile(fileData) {
            const addfileList = [];
            fileData.filter(item => {
                const url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${item}/download`;
                addfileList.push({ fileId: item, url: url, isImage: true });
            });
            this.fileList = addfileList;
        },
        selectGrid() {
            if (this.isDisabled || this.formData.Status !== 3) {return;}
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择存放位置',
                    sourcePath: 'dieselFuelRequisitionApprovalForm',
                    listCode: 'outstock_oil_select_grid',
                    requestUrl: `/basicplatform/tabledata?stock_id=${this.formData.StockId}&material_code=${this.formData.Materials[0].MaterialCode}`,
                    callbackDataKey: 'grid',
                    relationKey: 'grid_id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '库位编号',
                        code: 'grid_code',
                        isTitle: true,
                    }, {
                        name: '库位名称',
                        code: 'grid_name',
                        icon: 'icon_44@2x',
                    }, {
                        name: '实时库存',
                        code: 'volume_current',
                        icon: 'icon_16@2x',
                    }],
                },
            });
        },
        countVolumeOutstock(item) {
            // 禅道任务3585，备品备件：柴油领用审核柴油出库量（千克）计算方法修改
            item.VolumeOutstock = NP.round(NP.times(item.VolumeOutstockL || 0, item.VolumeCoefficient), 2);
            item.VolumeAfter = NP.minus(item.VolumeCurrent || 0, item.VolumeOutstock || 0);
        },
        submitForm(type) {
            const volumeAfterMasg = [];
            this.formData.Materials.forEach(item => {
                if (item.VolumeAfter < 0) {
                    volumeAfterMasg.push(item.MaterialCode);
                }
            });
            if (volumeAfterMasg.length > 0) {
                this.$toast.fail(`物料${volumeAfterMasg.join(',')} 库存不足`);
                return;
            }
            let messageText = '';
            let endMessageText = '';
            if (type === 3) {
                messageText = `确认提交出库单 \n【${this.formData.OutstockNumber}】吗？`;
                endMessageText = '提交成功。';
            } else if (type === 2) {
                messageText = `确认退回出库单 \n【${this.formData.OutstockNumber}】吗？`;
                endMessageText = '退回成功。';
            } else if (type === 4) {
                messageText = `确认出库单 \n【${this.formData.OutstockNumber}】出库吗？`;
                endMessageText = '出库成功。';
            }
            this.$dialog.confirm({
                message: messageText,
            }).then(async () => {
                this.formData.Status = type;
                const res = await this.submitRequest(this.formData);
                if (res) {
                    this.$toast.success(endMessageText);
                    setTimeout(() => {
                        this.isSaveOperation = true;
                        this.closeAllocationForm();
                    }, 1000);
                }
            });
        },
        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'dieselFuelRequisitionApproval',
                params: {
                    saveCallback: this.isSaveOperation,
                },
            });
        },
        getFormData(id) {
            return this.$axios.$get(`/interfaceApi/procurement/outstock_oil/${id}`);
        },
        submitRequest(requestData) {
            return this.$axios.$post('/interfaceApi/procurement/outstock_oil/change', requestData);
        },
    },
};
</script>
<style lang="stylus">
.dieselFuelRequisitionApprovalForm
    background #F0F0F0
    section
        height 0
        flex 1
    .formList
        padding 10rpx
        .formItem
            background #fff
            .photoUpload
                .van-cell
                    border none
                .file-list
                    padding 0 14rpx 10rpx
        .materialList
            margin 10rpx
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
            border-radius: 4rpx;
            overflow hidden
            dt
                height 42rpx
                background: #F8F8F8;
                border-bottom: 1px solid #E7E6E6;
                display flex
                align-items center
                padding 0 14rpx
                .van-icon
                    color #E93543
                    font-size 16rpx
                    margin-right 10rpx
                h5
                    font-size 16rpx
                    color #e93743
                p
                    margin-left auto
                    color #e93743
            dd
                padding 7rpx
                display flex
                flex-wrap wrap
                div
                    width 50%
                    padding 7rpx
                    &:last-child
                        width 100%
                    p
                        font-size 14rpx
                        color #626262
                        margin-bottom 6rpx
                    input
                        width 100%
                        height: 40px;
                        padding 0 6rpx
                        background: #FAFBFE;
                        border-radius: 4px;
                        border: 1px solid #ADC7E0;
                        &[disabled]
                            background: #F8F8F8
                            border-color #D7D7D7
                            color rgba(98, 98, 98, 0.7)
                            -webkit-text-fill-color rgba(98, 98, 98, 0.7)
</style>